module.exports = __webpack_public_path__ + "img/Group73@2x.6f986bcd.png";